/** @format */

import { memo } from 'react'

import styles from 'dir/styles/courses.module.css'
import m_first_ex_1Img from 'assets/images/m-first-ex-1.png'

export const _10 = memo(() => (
  <section className={styles.section}>
    <h2 className={styles.h2}>10 - Mobile-first CSS</h2>
    <p className={styles.description}>
      Когда мы говорим об responsive веб-сайтах, термин mobile-first сразу приходит в голову. Для наших целей нам в
      первую очередь интересна медиа-функция min-width, которая позволяет применять конкретные стили CSS, если окно
      браузера опускается ниже определенной ширины, которую мы можем указать.{' '}
    </p>
    <p className={styles.description}>
      Медиазапросы, использующие min-width, чрезвычайно полезны, когда дело доходит до написания responsive веб-сайтов,
      поскольку это снижает сложность кода. Однако запросы минимальной ширины не являются панацеей, иногда бывает
      полезно добавить запросы max-width в таблицу стилей.{' '}
    </p>
    <section className={styles.subsection}>
      <h3 className={styles.h3}>10.1 - Давайте рассмотрим пример</h3>
      <p className={styles.description}>
        У нас есть 4 блока на странице: хедер, список с 3-мя элементами, карта и футер. Дополнительно у нас есть два
        вспомогательных тега, container как общая обертка страницы и content как обертка для карты и списка. Слева
        отображено их расположение на телефоне. Справа на ноутбуке. Как вы думаете, в каком случае надо будет написать
        меньше css кода для позиционирования?{' '}
      </p>
      <img className={styles.img} src={m_first_ex_1Img} alt="mobile first" />
      <p className={styles.description}>
        Вспомним о потоке документа. Блоки в документе (по умолчанию) располагаются слева направо и сверху вниз. Думаю,
        вы уже догадались, что позиционировать элементы на картинке слева будет очень просто. Так как у нас элементы
        блочные достаточно просто написать html-разметку, и они встанут друг под другом. Плюсом будет то, что блочные
        элементы по умолчанию занимают 100% ширины родителя, поэтому нам не нужно в css задавать им явно ширину. Карты
        на узком экране нет, поэтому можем ее спрятать банальным display: none. В этом и есть сила mobile-first css.{' '}
      </p>
      <iframe
        height="300"
        scrolling="no"
        title="rotman_html_1_9_1"
        src="https://codepen.io/rotmanyan/embed/BdWPbK?default-tab=html%2Cresult&editable=true&theme-id=dark"
        frameBorder="no"
        loading="lazy"
        allowTransparency="true"
        allowFullScreen="true"
      />
      <p className={styles.notificationWarn}>
        Свойство <code className={styles.code}>min-width</code> у <code className={styles.code}>container</code>, это то
        значение ширины, ниже которого будет появляться полоса прокрутки. В современном вебе 320px считается минимально
        допустимой шириной экрана.{' '}
      </p>
      <p className={styles.description}>
        Заметьте, изначально даже нет media, так как стили пишутся для узкого экрана как база. Уже потом, при написании
        стилей для более широких экранов, мы добавляем media.{' '}
      </p>
      <p className={styles.description}>
        Теперь, используя mobile-first поход, добавим стили для более широкого экрана. Пусть для примера это будет 768px
        и шире. Добавим соответствующее media. Нам необходимо позиционировать карту и список рядом внутри content. Плюс
        карту нужно показать. Для примера дадим карте ширину 60%, а списку 40%. При верстке реального макета вы будете
        считать ширины блоков в % по формуле, которую мы изучили ранее.{' '}
      </p>
      <p className={styles.notificationWarn}>
        Представим ситуацию, когда мы начали делать верстку с более широкого экрана. То, что мы писали в media, мы бы
        написали без media, после чего на более узком экране нам бы пришлось в media переопределять display: flex для
        content, flex-basis для списка и карты и т.д. Думаю, вы уже видите преимущества modile-first css.{' '}
      </p>
    </section>
    <section className={styles.subsection}>
      <h3 className={styles.h3}>10.2 - Плюсы mobile-first css</h3>
      <ul className={styles.list}>
        <li className={styles.list__item}>
          Изначальный css более чистый, так как нам помогает поток документа и блочная модель при позиционировании
          элементов интерфейса{' '}
        </li>
        <li className={styles.list__item}>Наследование стилей от узких к широким экранам </li>
        <li className={styles.list__item}>
          Минимальное переопределение стилей позиционирования, следующее из первого пункта{' '}
        </li>
      </ul>
      <p className={styles.description}>
        И все же, min-width при mobile-first не является панацеей. Есть задачи, при mobile-first верстке которых решения
        очень элегантны. Достаточно добавить max-width или гибрида min-width to max-width медиаправил.
      </p>
      <p className={styles.notificationWarn}>
        По ссылке в дополнительных материалах вы можете наглядно разобрать пример такой ситуации, когда у нас есть, к
        примеру галерея, которая в зависимости от ширины экрана вмещает в строку разное количество элементов.{' '}
      </p>
    </section>
  </section>
))
